'use strict';

var FlightAnalysisPanelDirective = function FlightAnalysisPanelDirective() {
  return {
    restrict: 'E',
    controller: 'FlightAnalysisPanelController',
    template: require('../templates/flight-analysis-panel.html'),
    replace: true,
    scope: true
  };
};
FlightAnalysisPanelDirective.$inject = [];
module.exports = FlightAnalysisPanelDirective;